import { Component } from '@angular/core';

import { TranslationKeyMap } from './score-section-legend.i18n';

@Component({
    selector: 'cmps-ca-score-section-legend',
    templateUrl: './score-section-legend.component.html',
    host: {
        class: 'cmps-ca-score-section-legend',
    },
})
export class ScoreSectionLegendComponent {
    /** @private */
    _i18n = TranslationKeyMap;
}
